
    import { mapActions } from 'vuex';
    import { ValidationProvider } from 'vee-validate';
    import C1OccupationSelector from '@/C1Components/C1OccupationSelector.vue';
    import WhatIsThis from '@/components/Utils/WhatIsThis';
    import C1Label from '@/C1Components/C1Label';
    import C1Spinner from '@/C1Components/C1Spinner';
    import C1HelpText from '@/C1Components/C1HelpText';
    import SeekerAttributesNoResult from '@/components/Seeker/SeekerAttributesNoResult';

    export default {
        name: 'SeekerOccupations',

        components: {
            SeekerAttributesNoResult,
            C1HelpText,
            C1Spinner,
            ValidationProvider,
            C1Label,
            WhatIsThis,
            C1OccupationSelector,
        },

        props: {
            isRequired: {
                type: Boolean,
                default: false,
            },

            hideNoResultMessage: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                label: 'Desired occupations',
                id: `occupation_${this._uid}`,
                occupationsSelected: {
                    search: '',
                    occupations: [],
                },
                occupationsSearched: [],
                categories: [],
                spinner: {
                    get_init_data: false,
                },
            };
        },

        computed: {
            noResultText() {
                return `No ${this.label.toLowerCase()} added.`;
            },

            validationRules() {
                return this.isRequired ? 'required|occupation' : '';
            },
        },

        created() {
            this.getInitData();
        },

        methods: {
            ...mapActions('occupation', {
                $_getOccupationSuggestions: 'getOccupationSuggestions',
            }),

            ...mapActions('category', {
                $_getCategoriesWithOccupation: 'getCategoriesWithOccupation',
            }),

            ...mapActions('me', {
                $_getDesiredOccupations: 'getDesiredOccupations',
                $_syncDesiredOccupation: 'syncDesiredOccupation',
            }),

            getInitData() {
                this.spinner.get_init_data = true;
                Promise.all([this.$_getDesiredOccupations(), this.$_getCategoriesWithOccupation()]).then((response) => {
                    this.occupationsSelected.occupations = response[0].data;
                    this.categories = response[1];
                }).finally(() => {
                    this.spinner.get_init_data = false;
                });
            },

            searchOccupations(keyword) {
                if (keyword.length >= 3) {
                    this.$_getOccupationSuggestions({ keyword }).then((response) => {
                        this.occupationsSearched = response.data;
                    });
                } else if (keyword.length === 0) {
                    this.occupationsSearched = [];
                }
            },

            syncOccupations() {
                const data = {
                    occupation_ids: this.occupationsSelected.occupations.map(o => o.id),
                };

                this.$_syncDesiredOccupation(data);

                this.$refs.fieldOccupations.validate();
            },
        },
    };
